import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/** Sağdan açılan kurumsal detay paneli (slide-over). */
export const DetailPanel = ({ open, onClose, title, subtitle, icon: Icon, footer, children, testid, width = 'max-w-md' }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-slate-900/40 z-40 animate-in fade-in duration-150" onClick={onClose} data-testid={testid ? `${testid}-overlay` : undefined} />
      <aside
        className={`fixed right-0 top-0 bottom-0 w-full ${width} bg-white z-50 shadow-2xl border-l border-[#E2E8F0] flex flex-col animate-in slide-in-from-right duration-200`}
        data-testid={testid}
      >
        <div className="flex items-start gap-3 px-4 py-3.5 border-b border-[#E2E8F0] bg-[#0B172A] text-white">
          {Icon && <div className="rounded-lg bg-white/10 p-2 shrink-0"><Icon className="w-4 h-4" /></div>}
          <div className="min-w-0 flex-1">
            <h3 className="text-[15px] font-semibold truncate">{title}</h3>
            {subtitle && <p className="text-[11px] text-slate-300 truncate">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-white/10 text-slate-300" data-testid={testid ? `${testid}-close` : undefined}>
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
        {footer && <div className="border-t border-[#E2E8F0] p-3 bg-[#F8FAFC]">{footer}</div>}
      </aside>
    </>
  );
};

/** Panel içi etiket/değer satırı. */
export const DetailRow = ({ label, value, icon: Icon, accent }) => (
  <div className="flex items-start gap-2 py-2 border-b border-[#E2E8F0] last:border-0">
    {Icon && <Icon className="w-3.5 h-3.5 text-slate-400 mt-0.5 shrink-0" />}
    <span className="text-[12px] text-slate-500 w-[108px] shrink-0">{label}</span>
    <span className={`text-[13px] font-medium ${accent || 'text-slate-800'} break-words`}>{value ?? '-'}</span>
  </div>
);

export default DetailPanel;
